import { DI } from '../../../../apps/crossword-maker/src/shared/di';
import { IReplaceCategoryDataType } from '../../Api/CrosswordBook/CrosswordBookReplaceCategories.api';

export const ReplaceCrosswordBookCategoriesUseCase = () => {
    const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

    return {
        async execute(data: IReplaceCategoryDataType) {
            return await CrosswordBookRepository.replaceCategories(data);
        }
    }
}
